function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/goals-200");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 45 0 45 47.9999652 0 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 45 0 45 44.5217043 0 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0 45 0 45 44.5217043 0 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-480.000000, -681.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/goals-200",
  transform: "translate(480.000000, 681.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,47.9999652 L22.5,47.9999652 C10.0736719,47.9999652 0,38.0333565 0,25.7390957 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,25.7390957 C45,38.0333565 34.9263281,47.9999652 22.5,47.9999652",
  id: "Fill-1",
  fill: "#8E9FA8",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,44.5217043 L22.5,44.5217043 C10.0736719,44.5217043 0,34.5550957 0,22.2608348 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,22.2608348 C45,34.5550957 34.9263281,44.5217043 22.5,44.5217043",
  id: "Fill-4",
  fill: "#D6E4EF",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.78125,-3.47826087e-05 L4.21875,-3.47826087e-05 C1.88894531,-3.47826087e-05 0,1.86883478 0,4.17387826 L0,22.2608348 C0,34.5550957 10.0736719,44.5217043 22.5,44.5217043 C34.9263281,44.5217043 45,34.5550957 45,22.2608348 L45,4.17387826 C45,1.86883478 43.1110547,-3.47826087e-05 40.78125,-3.47826087e-05 M40.78125,4.17387826 L40.78125,22.2608348 C40.78125,32.2340522 32.5803516,40.3477913 22.5,40.3477913 C12.4196484,40.3477913 4.21875,32.2340522 4.21875,22.2608348 L4.21875,4.17387826 L40.78125,4.17387826",
  id: "Fill-7",
  fill: "#B6C4CE",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-10",
  stroke: "#8E9FA8",
  strokeWidth: 4.17391304,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "32.2809258 14.937287 20.2887773 26.8019826 14.1251836 20.7038957"
})))));

var SvgGoals200 = function SvgGoals200(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoals200, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goals-200.0f180de1.svg";
export { ForwardRef as ReactComponent };